<template>
  <section class="how-it-works-section">
    <div class="container">
      <div class="section-header">
        <div class="section-tag">
          <i class="fas fa-arrow-right"></i>
          <span>{{ content.header.tag }}</span>
        </div>
        <h2>{{ content.header.title }}</h2>
      </div>
      
      <div class="steps-container">
        <div class="step-card" v-for="(step, index) in content.steps" :key="index">
          <div class="step-icon">
            <i :class="step.icon"></i>
          </div>
          <div class="step-content">
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>
          <div class="step-number">{{ step.number }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AIMLItsHowWorkComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* How It Works Section */
.how-it-works-section {
  padding: 100px 0;
  background: linear-gradient(145deg, #0a0f1c, #1a2332);
  color: #fff;
  position: relative;
  overflow: hidden;
}

.how-it-works-section .section-header {
  text-align: center;
  margin-bottom: 80px;
}

.section-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(251, 14, 118, 0.1);
  border: 1px solid rgba(251, 14, 118, 0.3);
  padding: 8px 20px;
  border-radius: 25px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #FB0E76;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.section-tag i {
  font-size: 12px;
  color: #FB0E76;
}

.how-it-works-section .section-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  line-height: 1.2;
}

.steps-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.step-card {
  position: relative;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 20px;
  padding: 40px 30px;
  text-align: left;
  transition: all 0.3s ease;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
}

.step-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
  border-color: rgba(246, 236, 79, 0.3);
  background: rgba(255, 255, 255, 0.08);
}

.step-icon {
  width: 60px;
  height: 60px;
  background: transparent;
  border: 2px solid #FB0E76;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  transition: all 0.3s ease;
}

.step-card:hover .step-icon {
  background: rgba(251, 14, 118, 0.1);
  transform: scale(1.05);
}

.step-icon i {
  font-size: 24px;
  color: #FB0E76;
}

.step-content h3 {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  line-height: 1.3;
}

.step-content p {
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

.step-number {
  position: absolute;
  top: 20px;
  right: -2px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 14px;
  font-weight: 700;
  color: #FB0E76;
  letter-spacing: 2px;
  transform: rotate(180deg);
  padding: 15px 8px;
  background: #18202f;
  border: none;
  box-shadow: none;
  text-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .how-it-works-section {
    padding: 80px 0;
  }
  
  .how-it-works-section .section-header h2 {
    font-size: 36px;
  }
  
  .steps-container {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .step-card {
    padding: 30px 25px;
  }
  
  .step-icon {
    width: 50px;
    height: 50px;
  }
  
  .step-icon i {
    font-size: 20px;
  }
  
  .step-content h3 {
    font-size: 20px;
  }
  
  .step-content p {
    font-size: 15px;
  }
}

@media only screen and (max-width: 767px) {
  .how-it-works-section .section-header h2 {
    font-size: 28px;
  }
  
  .section-tag {
    font-size: 12px;
    padding: 6px 16px;
  }
  
  .step-card {
    padding: 25px 20px;
  }
  
  .step-number {
    top: 15px;
    right: 15px;
    font-size: 12px;
    padding: 10px 6px;
    letter-spacing: 1px;
  }
}
</style>
